import plant_lotus from "../assets/avatars/plants/lotus.webp";
import plant_waterlily_yellow from "../assets/avatars/plants/waterlily-yellow.webp";
import plant_mushroom from "../assets/avatars/plants/mushroom.webp";
import plant_iris from "../assets/avatars/plants/iris.webp";
import plant_wisteria from "../assets/avatars/plants/wisteria.webp";
import plant_lavender from "../assets/avatars/plants/lavender.webp";
import plant_hydrangea from "../assets/avatars/plants/hydrangea.webp";
import plant_peony from "../assets/avatars/plants/peony.webp";
import plant_camellia from "../assets/avatars/plants/camellia.webp";
import plant_magnolia from "../assets/avatars/plants/magnolia.webp";
import plant_poppy from "../assets/avatars/plants/poppy.webp";
import plant_cornflower from "../assets/avatars/plants/cornflower.webp";
import plant_cosmos from "../assets/avatars/plants/cosmos.webp";
import plant_daisy from "../assets/avatars/plants/daisy.webp";
import plant_sunflower from "../assets/avatars/plants/sunflower.webp";
import plant_forgetmenot from "../assets/avatars/plants/forgetmenot.webp";
import plant_bluebell from "../assets/avatars/plants/bluebell.webp";
import plant_tulip from "../assets/avatars/plants/tulip.webp";
import plant_daffodil from "../assets/avatars/plants/daffodil.webp";
import plant_anemone from "../assets/avatars/plants/anemone.webp";
import plant_ginkgo from "../assets/avatars/plants/ginkgo.webp";
import plant_maple from "../assets/avatars/plants/maple.webp";
import plant_fern from "../assets/avatars/plants/fern.webp";
import plant_eucalyptus from "../assets/avatars/plants/eucalyptus.webp";
import plant_clover from "../assets/avatars/plants/clover.webp";
import plant_lily_pad from "../assets/avatars/plants/lily-pad.webp";
import plant_reed from "../assets/avatars/plants/reed.webp";
import plant_bamboo from "../assets/avatars/plants/bamboo.webp";
import plant_willow from "../assets/avatars/plants/willow.webp";
import plant_olive from "../assets/avatars/plants/olive.webp";
import fish_koi from "../assets/avatars/fish/koi.webp";
import fish_goldfish from "../assets/avatars/fish/goldfish.webp";
import fish_betta from "../assets/avatars/fish/betta.webp";
import fish_gourami from "../assets/avatars/fish/gourami.webp";
import fish_paradise from "../assets/avatars/fish/paradise.webp";
import fish_medaka from "../assets/avatars/fish/medaka.webp";
import fish_angelfish from "../assets/avatars/fish/angelfish.webp";
import fish_discus from "../assets/avatars/fish/discus.webp";
import fish_guppy from "../assets/avatars/fish/guppy.webp";
import fish_cherry_barb from "../assets/avatars/fish/cherry-barb.webp";
import "./Avatar.css";

const PLANTS = [
  plant_lotus,
  plant_waterlily_yellow,
  plant_mushroom,
  plant_iris,
  plant_wisteria,
  plant_lavender,
  plant_hydrangea,
  plant_peony,
  plant_camellia,
  plant_magnolia,
  plant_poppy,
  plant_cornflower,
  plant_cosmos,
  plant_daisy,
  plant_sunflower,
  plant_forgetmenot,
  plant_bluebell,
  plant_tulip,
  plant_daffodil,
  plant_anemone,
  plant_ginkgo,
  plant_maple,
  plant_fern,
  plant_eucalyptus,
  plant_clover,
  plant_lily_pad,
  plant_reed,
  plant_bamboo,
  plant_willow,
  plant_olive,
];
const FISH = [
  fish_koi,
  fish_goldfish,
  fish_betta,
  fish_gourami,
  fish_paradise,
  fish_medaka,
  fish_angelfish,
  fish_discus,
  fish_guppy,
  fish_cherry_barb,
];

/** A stable identity keeps its painted portrait across renames, routes and sizes. */
function portrait(identity: string, glyph: "agent" | "person") {
  let hash = 2166136261;
  for (const letter of identity) hash = Math.imul(hash ^ letter.codePointAt(0)!, 16777619);
  const family = glyph === "person" ? FISH : PLANTS;
  return family[((hash ^ (hash >>> 16)) >>> 0) % family.length];
}

/** Decoration only: the adjacent name remains the accessible identity. */
export function Avatar({ name, identity, size = "md", glyph = "agent", className = "" }: {
  name: string; identity?: string | null; size?: "sm" | "md" | "lg"; glyph?: "agent" | "person";
  className?: string;
}) {
  const source = portrait(identity || name.trim() || "default", glyph);
  return <span className={`pa-avatar pa-avatar-${size}${className ? ` ${className}` : ""}`} aria-hidden="true">
    <img src={source} alt="" width="128" height="128" decoding="async" draggable={false} />
  </span>;
}
